const COVERS = [
  '00a1870e552cd5e5537622943ed3d062.jpg',
  '01b1f029da6ed13f16d537f65898516d.jpg',
  '08cdadd292d75e29094e9dfbc6a1c53c.jpg',
  '0dce45c6230016e43035423b3a6add6c.jpg',
  '1f5acce83d85623d5228a1a7a717cf41.jpg',
  '2f9003b092c1bcb039b8cca830b15fe6.jpg',
  '31e166de86210ff8994b4cd55e4df8dc.jpg',
  '3c67011c1284ec96eae1eb6df66afe77.jpg',
  '438ccc5d3cbff4519115b72257052e20.jpg',
  '4bf30a3b9aab54d1605c176b38634c5d.jpg',
  '51080b5730d00145291f8f796f11803a.jpg',
  '53ada86d35b0fe6685e2ecc1806c8a62.jpg',
  '55c0af739d2c2f7398ee5a1d74f00fe6.jpg',
  '68fca03d3fa7b9f42a94e2f8ccdacc71.jpg',
  '6cac76679fdb02260cba75e3f7ad8333.jpg',
  '725292e84db943a8c69b4605b6049867.jpg',
  '75342da40c31964ef41706f256aa3dc9.jpg',
  '796db036283741a9b7e89ec0171e8ed7.jpg',
  '831eb2dc92b492845bf9ca997504ac4d.jpg',
  '9c9de3cec4c53ed7343d3ac188712afc.jpg',
  'a817a9d89f374b11c8b32324ac4ba32a.jpg',
  'b14901fe666cc70e633ddba380ebcad4.jpg',
  'cdcc51f55b7147e6fc7965dce77bdd0c.jpg',
  'd1af724ff4004265dc721ea61f44e966.jpg',
  'e57024ca1f5f686a94c06ae49568554d.jpg',
  'e7bf4e55ca9e70d16b0d966b7874f941.jpg',
  'f6dece9ea4ed976a3ec6cd40b131190f.jpg',
  'f96bd797742c8ddc4b80ecb082b78bc0.jpg',
];

const URLS = [
  'https://fqm3u8.com/20250209/i1WDbgiy/index.m3u8',
  'https://fqm3u8.com/20250218/rewJ6owO/1100kb/hls/index.m3u8',
  'https://fqm3u8.com/20250216/QrWs31ts/1100kb/hls/index.m3u8',
  'https://fqm3u8.com/20250208/cWsJ8jWK/1100kb/hls/index.m3u8',
  'https://fqm3u8.com/20250209/2vyyrGoB/1100kb/hls/index.m3u8',
];

export function movieList() {
  return COVERS.map((file, i) => ({
    id: i + 1,
    pic: '/img/shangchang/dianying/' + file,
    url: URLS[i % URLS.length],
  }));
}

export function movieById(id) {
  const list = movieList();
  const n = Number(id);
  return list.find((item) => item.id === n) || list[0];
}
